module.exports = __webpack_public_path__ + "static/media/IMG_8755.72a05f3f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/horizontal/IMG_8755.jpg
// module id = 152
// module chunks = 0